import React from 'react';
import clsx from 'clsx';
import { Grid, makeStyles } from '@material-ui/core';
import { colors, H4Text } from 'design-system';
import { Check } from 'react-feather';

const useStyles = makeStyles(() => ({
  fakeRadio: {
    width: 24,
    height: 24,
    borderRadius: 12,
    border: `2px solid ${colors.bright_turquoise}`,
    marginRight: 10,
  },
  checkedRadio: {
    backgroundColor: colors.bright_turquoise,
  },
  container: {
    marginTop: 17,
    marginBottom: 3,
  },
}));

type Props = {
  name: string;
};

const AdditionalBenefits = ({ name }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid
      container
      alignItems="center"
      className={classes.container}
      data-testid={`additional-benefits-${name}`}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        item
        className={clsx(classes.fakeRadio, classes.checkedRadio)}
      >
        <Check color={colors.white} size={16} />
      </Grid>
      <Grid item>
        <H4Text style={{ textTransform: 'capitalize' }}>
          {name.toLowerCase()}
        </H4Text>
      </Grid>
    </Grid>
  );
};

export default AdditionalBenefits;
